import { event } from "@zillow/universal-analytics";
function trackHubspotEmbedView(embedId, portalId) {
  event({
    // https://dataportal.zillowgroup.net/event-registry/2284
    envelope: {
      event_type_id: "2284",
      event_type_version_id: "1",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "view",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_hubspot_embed",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "view_content"
    },
    cms_info: {
      block_type_cd: "hubspot_embed",
      block_id: embedId,
      hubspot_portal_id: portalId,
      hubspot_embed_id: embedId
    }
  });
}
function trackHubspotEmbedHover(embedId, elementText, elementType) {
  event({
    // https://dataportal.zillowgroup.net/event-registry/2056
    envelope: {
      event_type_id: "2056",
      event_type_version_id: "3",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "hover",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_hubspot_embed",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: {
      block_type_cd: "hubspot_embed",
      block_id: embedId,
      block_displayed_txt: elementText,
      element_type_txt: elementType
    }
  });
}
function trackHubspotEmbedInteraction(embedId, interactionType, elementText, elementUrl) {
  event({
    // https://dataportal.zillowgroup.net/event-registry/2048
    envelope: {
      event_type_id: "2048",
      event_type_version_id: "4",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_hubspot_embed",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_click"
    },
    cms_info: {
      block_type_cd: "hubspot_embed",
      block_id: embedId,
      block_displayed_txt: elementText,
      block_target_url: elementUrl || "",
      interaction_type_txt: interactionType
    }
  });
}
function trackHubspotFormSubmit(embedId, formId, isValid, submitSuccess, fields) {
  event({
    // https://dataportal.zillowgroup.net/event-registry/2055
    envelope: {
      event_type_id: "2055",
      event_type_version_id: "1",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_hubspot_embed",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_submit"
    },
    cms_info: {
      block_type_cd: "hubspot_form",
      block_id: formId,
      hubspot_embed_id: embedId,
      form_form_is_valid_ind: isValid,
      form_submit_success_ind: submitSuccess,
      ...fields && {
        form_fields: fields
      }
    }
  });
}
function trackHubspotFormFieldChange(embedId, fieldName, fieldLabel) {
  event({
    // https://dataportal.zillowgroup.net/event-registry/2056
    envelope: {
      event_type_id: "2056",
      event_type_version_id: "3",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_hubspot_embed",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: {
      block_type_cd: "form_field",
      block_id: fieldName,
      block_displayed_txt: fieldLabel,
      hubspot_embed_id: embedId
    }
  });
}
export {
  trackHubspotEmbedHover,
  trackHubspotEmbedInteraction,
  trackHubspotEmbedView,
  trackHubspotFormFieldChange,
  trackHubspotFormSubmit
};
